export default __webpack_public_path__ + "static/media/Level13.84903a17.svg";